/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';

const useUnmount = () => {
  useEffect(() => () => {
  }, []);
};

export default useUnmount;
